import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

const BarRowsSkeleton = ({ rows }: { rows: number }) => (
  <div className="flex flex-col gap-3">
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="flex flex-col gap-1.5">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-2 w-full rounded-full" />
      </div>
    ))}
  </div>
);

/** Szkielet zakładki statystyk — układ kart taki sam jak w `TourStatsTab`. */
const TourStatsTabSkeleton = () => (
  <div className="flex flex-col gap-4">
    <InfoCard>
      <InfoCardHeader title={<Skeleton className="h-3 w-40" />} />
      <InfoCardBody>
        <Skeleton className="h-[220px] w-full" />
      </InfoCardBody>
    </InfoCard>

    <InfoCard>
      <InfoCardHeader title={<Skeleton className="h-3 w-28" />}>
        <Skeleton className="mt-2 h-7 w-48" />
      </InfoCardHeader>
      <InfoCardBody>
        <Skeleton className="h-[300px] w-full" />
      </InfoCardBody>
    </InfoCard>

    <div className="grid gap-4 lg:grid-cols-2">
      <InfoCard>
        <InfoCardHeader title={<Skeleton className="h-3 w-32" />} />
        <InfoCardBody>
          <BarRowsSkeleton rows={4} />
        </InfoCardBody>
      </InfoCard>

      <InfoCard>
        <InfoCardHeader title={<Skeleton className="h-3 w-32" />} />
        <InfoCardBody className="gap-0 py-1">
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={index}
              className="flex items-center justify-between gap-3 border-neutral-100 py-3.5 [&:not(:first-child)]:border-t"
            >
              <Skeleton className="h-4 w-44" />
              <Skeleton className="h-5 w-20" />
            </div>
          ))}
        </InfoCardBody>
      </InfoCard>
    </div>

    <InfoCard>
      <InfoCardHeader title={<Skeleton className="h-3 w-24" />} />
      <InfoCardBody>
        <div className="grid gap-6 md:grid-cols-2">
          <BarRowsSkeleton rows={4} />
          <BarRowsSkeleton rows={3} />
        </div>
      </InfoCardBody>
    </InfoCard>
  </div>
);

export default TourStatsTabSkeleton;
